import React, { FC, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import location from "../assets/images/8929788.png";
import sayeda from "../assets/images/sayeda.png";
import sayeda2 from "../assets/images/sayeda2.jpeg";

import jbeniana from "../assets/images/jbeniana2.jpg";

import djebeniana from "../assets/images/jbeniana.png";
import zarzis from "../assets/images/lavageZarzis.jpg";
import zarzis2 from "../assets/images/zarzis2.jpg";

import alkhalil from "../assets/images/al khalil.jpg";

import alkhalil2 from "../assets/images/alkhalil2.jpg";

import rgueb from "../assets/images/lavageregueb.jpg";
import rgueb2 from "../assets/images/rgeb2.jpg";

import amraa2 from "../assets/images/amraaa.jpg";

import amraa from "../assets/images/lavageamra.jpg";
import houmetsouk from "../assets/images/lavagehoumetsouk.png";
import houmetsouk2 from "../assets/images/jerbahoumetsouk.jpg";

import ola4 from "../assets/NosStations/ola4.jpeg";
import raboudi from "../assets/images/darchaabenefehri.jpg";

import Bizerte3 from "../assets/images/lavageGharbi.png";

import djerbamidoun from "../assets/djerbamidoun.jpeg";

import mednine3 from "../assets/NosStations/mednine3.jpeg";
import mednine2 from "../assets/NosStations/mednine2.jpeg";

import gabes1 from "../assets/images/lavageGabes.png";
import gabes2 from "../assets/images/gabes2.jpg";

import olasahline3 from "../assets/NosStations/olasahline3.jpeg";
import olasahline2 from "../assets/NosStations/olasahline2.jpeg";

import olatazarka1 from "../assets/images/lavageolatazarka.png";
import stationali from "../assets/images/stationAli.jpeg";
import stationali2 from "../assets/images/ali2.jpeg";

/* =========================================================
   HZAG
   ========================================================= */
import hzag1 from "../assets/images/hzag1.jpeg";
import hzag2 from "../assets/images/hzag2.jpeg";
import hzag3 from "../assets/images/hzag3.jpeg";


type Station = {
  image: string | null;
  gallery?: string[];
  alt: string;
  title: string;
  description: string;
  mapHref: string;
  linkLabel: string;
  comingSoon?: boolean;
};


const stations: Station[] = [
  {
    image: djebeniana,
    gallery: [
      djebeniana,
      jbeniana,
    ],
    alt: "Djebeniana",
    title: "Let's Wash Park Djebeniana",
    description:
      "Implantée à Djebeniana, cette station marque le début de notre engagement à fournir des services de lavage de qualité.",
    mapHref: "https://maps.app.goo.gl/TVqYAAXS7sYkvnZX9",
    linkLabel: "Localisation Let's Wash Park Djebeniana",
  },

  {
    image: amraa,
    gallery: [
      amraa,
      amraa2,
    ],
    alt: "Amra",
    title: "Let's Wash Park Al Amra",
    description:
      "À Al Amra, bénéficiez d'un lavage pratique et rapide adapté à tous types de véhicules.",
    mapHref: "https://maps.app.goo.gl/ftvmvgvQnPve3BDL7",
    linkLabel: "Localisation Let's Wash Park Al Amra",
  },

  {
    image: alkhalil,
    gallery: [
      alkhalil,
      alkhalil2,
    ],
    alt: "Al Khalil",
    title: "Let's Wash Park Al Khalil",
    description:
      "La station Al Khalil, située à Sakiet Ezzit, met à votre disposition un service de lavage professionnel et soigné.",
    mapHref: "https://maps.app.goo.gl/3qJWCM2wDZfH3esZ8",
    linkLabel: "Localisation Let's Wash Park Al Khalil",
  },

  {
    image: gabes1,
    gallery: [
      gabes1,
      gabes2,
    ],
    alt: "Gabès",
    title: "Let's Wash Park Gabès",
    description:
      "À Gabès, bénéficiez d'un lavage adapté à vos besoins avec un service rapide.",
    mapHref: "https://maps.app.goo.gl/qnypjiuQi97UDyZaA?g_st=aw",
    linkLabel: "Localisation Let's Wash Park Gabès",
  },

  {
    image: rgueb,
    gallery: [
      rgueb,
      rgueb2,
    ],
    alt: "Regueb",
    title: "Let's Wash Park Regueb",
    description:
      "Située à Regueb, notre station offre un service rapide et efficace pour votre véhicule.",
    mapHref: "https://maps.app.goo.gl/fwrnS1wXKX71178c8",
    linkLabel: "Localisation Let's Wash Park Regueb",
  },

  {
    image: mednine3,
    gallery: [
      mednine3,
      mednine2,
    ],
    alt: "Medenine",
    title: "Let's Wash Park Médenine",
    description:
      "À Médenine, profitez d'une station moderne offrant un service de lavage rapide, professionnel et adapté à tous les types de véhicules.",
    mapHref: "https://maps.app.goo.gl/9AKhyphezC4yYssu9",
    linkLabel: "Localisation Let's Wash Park Médenine",
  },

  {
    image: zarzis,
    gallery: [
      zarzis,
      zarzis2,
    ],
    alt: "Zarzis",
    title: "Let's Wash Park Zarzis",
    description:
      "À Zarzis, profitez d'une station moderne offrant un service de lavage rapide, professionnel et adapté à tous les types de véhicules.",
    mapHref: "https://maps.app.goo.gl/A87CTuNde43AwCkZ7",
    linkLabel: "Localisation Let's Wash Park Zarzis",
  },

  {
    image: houmetsouk,
    gallery: [
      houmetsouk,
      houmetsouk2,
    ],
    alt: "Houmet Souk",
    title: "Let's Wash Park Djerba Houmet Souk",
    description:
      "À Djerba Houmet Souk, profitez d'une station de lavage moderne offrant un service rapide, accessible et performant pour tous types de véhicules.",
    mapHref: "https://maps.app.goo.gl/5ZHnZuLzb7Ytaj8P7",
    linkLabel: "Localisation Let's Wash Park Houmet Souk",
  },

  {
    image: djerbamidoun,
    alt: "Djerba Midoun",
    title: "Let's Wash Park Djerba Midoun",
    description:
      "À Djerba Midoun, notre station garantit un lavage fiable et de qualité.",
    mapHref: "https://maps.app.goo.gl/kvw7bTGDpVxKC4dg6",
    linkLabel: "Localisation Let's Wash Park Midoun",
  },

  {
    image: stationali,
    gallery: [
      stationali,
      stationali2,
    ],
    alt: "Let's Wash Ali",
    title: "Let's Wash Ali",
    description:
      "Découvrez notre station Let's Wash Ali, une station moderne offrant un service de lavage rapide, pratique et efficace pour tous types de véhicules.",
    mapHref: "https://maps.app.goo.gl/GK4Ryrxk31s9ZCYE8?g_st=iw",
    linkLabel: "Localisation Let's Wash Ali",
  },

  {
    image: Bizerte3,
    alt: "Gharbi",
    title: "Let's Wash Park Gharbi",
    description:
      "La station Gharbi, située à Bizerte, vous propose un nettoyage efficace grâce à des équipements modernes.",
    mapHref: "https://maps.app.goo.gl/1oMRF2YoNtfQ8ogV9?g_st=aw",
    linkLabel: "Localisation Let's Wash Park Gharbi",
  },

  {
    image: ola4,
    gallery: [
      ola4,
      raboudi,
    ],
    alt: "Let's Wash Raboudi",
    title: "Let's Wash Raboudi",
    description:
      "Notre station de lavage située à Dar Chaâbane El Fehri propose un service moderne, rapide et efficace pour tous types de véhicules.",
    mapHref: "https://maps.app.goo.gl/NcZg1Ws3wTWEF7U5A?g_st=aw",
    linkLabel: "Localisation Let's Wash Raboudi",
  },

  {
    image: olatazarka1,
    alt: "Olatazarka",
    title: "Let's Wash Park Olatazarka",
    description:
      "À Ola Tazarka, profitez d'un service de lavage rapide et professionnel.",
    mapHref: "https://maps.app.goo.gl/6CvUCjtTtVnD5hZf7?g_st=aw",
    linkLabel: "Localisation Let's Wash Park Olatazarka",
  },

  {
    image: olasahline3,
    gallery: [
      olasahline3,
      olasahline2,
    ],
    alt: "Ola Sahline",
    title: "Let's Wash Park Olasahline",
    description:
      "La station Ola Sahline assure un lavage moderne, pratique et accessible avec un service rapide et efficace pour tous types de véhicules.",
    mapHref: "https://maps.app.goo.gl/6xBvouHUx8K8RwfK7",
    linkLabel: "Localisation Let's Wash Park Olasahline",
  },

  {
    image: sayeda,
    gallery: [
      sayeda,
      sayeda2,
    ],
    alt: "Let's Wash Sayeda",
    title: "Let's Wash Sayeda",
    description:
      "À Sayeda, profitez d'une station de lavage moderne offrant un service rapide, pratique et de qualité pour tous les types de véhicules.",
    mapHref: "https://maps.app.goo.gl/yEZc9tVKwNTwojc97?g_st=ac",
    linkLabel: "Localisation Let's Wash Sayeda",
  },

  /* =========================================================
     HZAG
     ========================================================= */
  {
    image: hzag1,
    gallery: [
      hzag1,
      hzag2,
      hzag3,
    ],
    alt: "HZAG",
    title: "Let's Wash Park HZAG",
    description:
      "À HZAG, profitez d’un service de lavage moderne, rapide et adapté à tous types de véhicules.",
    mapHref:
      "https://maps.app.goo.gl/eQ93ZQgk8gkkFwucA",
    linkLabel: "Localisation Let's Wash Park HZAG",
  },
];


const StationCard: FC<{
  station: Station;
  onOpen: () => void;
}> = ({ station, onOpen }) => {

  // Liste des images à faire défiler
  // Galerie si elle existe, sinon l'image unique
  const images =
    station.gallery && station.gallery.length > 0
      ? station.gallery
      : station.image
      ? [station.image]
      : [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  React.useEffect(() => {
    if (images.length <= 1 || isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length, isPaused]);

  return (
    <div
      className="group flex w-full sm:max-w-sm md:max-w-md flex-col overflow-hidden rounded-2xl bg-white border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >

      {/* IMAGE / GALERIE */}
      <div className="relative h-52 sm:h-56 md:h-64 w-full overflow-hidden bg-gray-100">

        {images.length > 0 ? (
          <img
            key={currentIndex}
            src={images[currentIndex]}
            alt={station.alt}
            onClick={onOpen}
            className="h-full w-full object-cover cursor-pointer transition-all duration-700 ease-in-out group-hover:scale-110"
          />
        ) : (
          <div className="h-full w-full flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-gray-100">

            <svg
              className="w-10 h-10 text-blue-300 mb-2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                strokeWidth="2"
              />

              <path
                d="M12 7V12L15 14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <span className="text-blue-400 text-sm font-semibold uppercase tracking-wide">
              Bientôt
            </span>
          </div>
        )}

        {station.image && (
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
        )}

        {station.comingSoon && (
          <span className="absolute top-3 right-3 bg-yellow-400 text-blue-900 text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full shadow">
            Bientôt
          </span>
        )}

        {/* INDICATEURS */}
        {images.length > 1 && (
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">

            {images.map((_, idx) => (
              <span
                key={idx}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  idx === currentIndex
                    ? "w-4 bg-white"
                    : "w-1.5 bg-white/50"
                }`}
              />
            ))}

          </div>
        )}

      </div>


      {/* CONTENU */}
      <div className="flex flex-1 flex-col p-6">

        <div className="mb-3 h-1 w-10 rounded-full bg-yellow-400 group-hover:w-16 transition-all duration-300"></div>

        {/* NOM DE LA STATION */}
        <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">
          {station.title}
        </h3>

        <p className="text-gray-600 text-xs sm:text-sm leading-relaxed flex-1">
          {station.description}
        </p>

        {/* LOCALISATION */}
        <a
          href={station.mapHref}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-4 sm:px-5 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wide text-white shadow-md transition-all duration-300 hover:bg-blue-700 hover:shadow-blue-500/40"
        >

          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 21C12 21 19 15.5 19 10.5C19 6.4 15.6 3 12 3C8.4 3 5 6.4 5 10.5C5 15.5 12 21 12 21Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />

            <circle
              cx="12"
              cy="10.5"
              r="2.5"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>

          Localisation

        </a>

      </div>

    </div>
  );
};


const NosStations: FC = () => {

  const [selectedGallery, setSelectedGallery] = useState<string[] | null>(
    null
  );

  const [selectedGalleryIndex, setSelectedGalleryIndex] = useState(0);

  const [selectedImageAlt, setSelectedImageAlt] = useState<string>("");

  const [isModalPaused, setIsModalPaused] = useState(false);


  const openImageModal = (
    image: string,
    alt: string,
    gallery: string[] = [],
    index = 0
  ) => {

    setSelectedGallery(
      gallery.length > 0 ? gallery : [image]
    );

    setSelectedGalleryIndex(index);

    setSelectedImageAlt(alt);
  };


  const closeImageModal = () => {
    setSelectedGallery(null);
  };


  // Défilement automatique des images dans le modal plein écran
  React.useEffect(() => {

    if (
      !selectedGallery ||
      selectedGallery.length <= 1 ||
      isModalPaused
    ) {
      return;
    }

    const interval = setInterval(() => {

      setSelectedGalleryIndex(
        (prev) => (prev + 1) % selectedGallery.length
      );

    }, 3000);

    return () => clearInterval(interval);

  }, [selectedGallery, isModalPaused]);


  return (
    <div className="min-h-screen bg-gray-50">

      {/* =====================================================
          HERO
      ====================================================== */}

      <div className="relative bg-gradient-to-br from-blue-700 via-blue-700 to-blue-900 pt-28 sm:pt-32 md:pt-40 pb-16 sm:pb-20 md:pb-28 px-4 sm:px-6 text-center overflow-hidden">

        <div className="relative z-10 max-w-3xl mx-auto">

          <span className="inline-flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-[0.25em] uppercase mb-4">

            <span className="w-8 h-px bg-yellow-400"></span>

            Partout en Tunisie

            <span className="w-8 h-px bg-yellow-400"></span>

          </span>


          <h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-black text-white mb-6">
            Nos Stations
          </h1>


          <p className="text-blue-100/90 text-sm sm:text-base md:text-lg leading-relaxed px-2">
            Trouvez la station la plus proche de vous dans votre gouvernorat
            et profitez de nos services partout en Tunisie.
          </p>

        </div>

      </div>


      {/* =====================================================
          STATIONS
      ====================================================== */}

      <div className="px-4 sm:px-6 pb-16">

        <section className="pt-16">

          <div className="flex flex-col items-center mb-10">

            <span className="text-yellow-500 text-xs font-bold tracking-[0.2em] uppercase mb-2">
              Nos stations
            </span>

            <div className="mt-4 h-1.5 w-16 rounded-full bg-gradient-to-r from-blue-600 to-yellow-400"></div>

          </div>


          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 justify-items-center">

            {stations.map((station) => (

              <StationCard
                key={station.title}
                station={station}
                onOpen={() =>
                  station.image &&
                  openImageModal(
                    station.image,
                    station.alt,
                    station.gallery ?? [station.image],
                    0
                  )
                }
              />

            ))}

          </div>

        </section>

      </div>


      {/* =====================================================
          MODAL - GALERIE PLEIN ÉCRAN
      ====================================================== */}

      {selectedGallery && (

        <div
          className="fixed inset-0 flex items-center justify-center bg-black"
          style={{ zIndex: 99999 }}
          onClick={closeImageModal}
          onMouseEnter={() => setIsModalPaused(true)}
          onMouseLeave={() => setIsModalPaused(false)}
        >

          {/* FERMER */}
          <button
            type="button"
            onClick={closeImageModal}
            className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-2xl font-light text-white transition-colors"
            style={{ zIndex: 100000 }}
          >
            ×
          </button>


          {/* BOUTONS PRECEDENT / SUIVANT */}
          {selectedGallery.length > 1 && (
            <>

              {/* PRECEDENT */}
              <button
                type="button"
                onClick={(event) => {

                  event.stopPropagation();

                  setSelectedGalleryIndex(
                    (prev) =>
                      prev === 0
                        ? selectedGallery.length - 1
                        : prev - 1
                  );

                }}
                className="absolute left-1 sm:left-4 top-1/2 -translate-y-1/2 flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-xl sm:text-2xl text-white transition-colors"
                style={{ zIndex: 100000 }}
              >
                ‹
              </button>


              {/* SUIVANT */}
              <button
                type="button"
                onClick={(event) => {

                  event.stopPropagation();

                  setSelectedGalleryIndex(
                    (prev) =>
                      prev === selectedGallery.length - 1
                        ? 0
                        : prev + 1
                  );

                }}
                className="absolute right-1 sm:right-4 top-1/2 -translate-y-1/2 flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-xl sm:text-2xl text-white transition-colors"
                style={{ zIndex: 100000 }}
              >
                ›
              </button>

            </>
          )}


          {/* IMAGE */}
          <img
            src={selectedGallery[selectedGalleryIndex]}
            alt={selectedImageAlt}
            onClick={(event) => event.stopPropagation()}
            className="max-h-[90vh] max-w-[95vw] w-auto h-auto object-contain"
            style={{
              zIndex: 100000,
              position: "relative",
            }}
          />


          {/* COMPTEUR */}
          <div
            className="absolute bottom-4 left-1/2 -translate-x-1/2 text-center text-sm text-white/80"
            style={{ zIndex: 100000 }}
          >
            {selectedImageAlt} (
            {selectedGalleryIndex + 1}/
            {selectedGallery.length}
            )
          </div>

        </div>

      )}

    </div>
  );
};


export default NosStations;